import React from 'react';
import { Dialog } from '@tencent/spaui';
import { QRCodeCanvas } from 'qrcode.react';

import './index.scoped.less';

const Qrcode = (props: {
  url: string;
  onClose: () => void;
}) => {
  const { url = '', onClose } = props;

  return <Dialog
    useNewUI={true}
    show={!!url}
    title="合同签署"
    size="large"
    onSubmit={onClose}
    onClose={onClose}
    cancelButton={false}
  >
    <div className="contract-qrcode">
      <QRCodeCanvas value={url} size={196} />
      <div>请企业相关负责人使用微信扫码进入合同签署流程</div>
    </div>
  </Dialog>;
};

export default Qrcode;
